import { action, observable, makeObservable } from 'mobx';
import { eventBus, subscribe } from 'mobx-event-bus2';

import { UserRole } from 'core/constants';

import { OrganisationResponse, UuidableName } from 'utils/api/types';
import {
  EditUserResponse,
  VehicleDetailsResponse,
  ContactDetailsResponse,
  UserLicensesResponse,
  UserNameResponse,
  UserAttributesResponse,
} from 'utils/api/modules/user/user.types';
import { AlarmResponseProfileResponse } from 'utils/api/modules/alarms/alarms.types';
import { EventType } from 'utils/events/constants';
import { ActionEvent, UpdatedProfilePayload } from 'utils/events/types';

import UserPersonalDetails from '../UserDetails/UserPersonalDetails';

export default class EditUserData {
  uuid: string;

  @observable name: string;

  @observable role: UserRole;

  organisation: OrganisationResponse;

  email: string;

  @observable phoneNumber: string | null;

  @observable personalDetails: UserPersonalDetails;

  @observable alarmResponseProfile: AlarmResponseProfileResponse | null;

  @observable vehicleDetails: VehicleDetailsResponse[];

  @observable contactDetails: ContactDetailsResponse[];

  @observable groups: UuidableName[];

  @observable licenses: UserLicensesResponse;

  @observable dateJoined: string;

  @observable manager: UserNameResponse | null;

  @observable attributes: UserAttributesResponse | null;

  constructor(data: EditUserResponse) {
    makeObservable(this);
    this.uuid = data.uuid;
    this.name = data.name;
    this.email = data.email;
    this.phoneNumber = data.phoneNumber;
    this.role = data.role;
    this.organisation = data.organisation;
    this.personalDetails = new UserPersonalDetails(data.personalDetails);
    this.alarmResponseProfile = data.alarmResponseProfile;
    this.vehicleDetails = data.vehicleDetails;
    this.contactDetails = data.contactDetails;
    this.groups = data.groups;
    this.licenses = data.licenses;
    this.dateJoined = data.dateJoined;
    this.manager = data.manager;
    this.attributes = data.attributes;

    eventBus.register(this);
  }

  @subscribe(EventType.UpdatedProfile)
  @action
  updatedProfile({ payload }: ActionEvent<UpdatedProfilePayload>): void {
    if (payload.uuid !== this.uuid) {
      return;
    }

    this.name = payload.name;
    this.role = payload.role;
    this.phoneNumber = payload.phoneNumber;
  }
}
